<!-- <ng-container *ngIf="dialogRef">
    <h4 mat-dialog-title>
        <ng-template [ngTemplateOutlet]="title"></ng-template>
    </h4>
    <mat-dialog-content>
        <ng-template [ngTemplateOutlet]="body"></ng-template>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button
            [disabled]="!resourceId || !date || loading"
            type="button"
            cdkFocusInitial
            mat-button
            (click)="accept()"
            translate="Job.Schedule"
            data-cy="schedule-job-accept"
        ></button>
        <button
            type="button"
            mat-button
            (click)="cancel()"
            translate="System.Cancel"
        ></button>
    </mat-dialog-actions>
</ng-container> -->


<!-- <ng-container *ngIf="modalRef"> -->
    <div class="modal-header">
        <h4 class="modal-title">
            <ng-template [ngTemplateOutlet]="title"></ng-template>
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ng-template [ngTemplateOutlet]="body"></ng-template>
    </div>
    <div class="modal-footer">
        <ng-template [ngTemplateOutlet]="footer"></ng-template>
    </div>
<!-- </ng-container> -->

<ng-template #title>
    {{ "Job.Schedule" | translate }} {{ job | job : "cleanJobId" }}
</ng-template>

<ng-template #body>

        <h5>{{ resourceName(resourceId) }}</h5>
        <div class="d-flex flex-row">
            <abi-form-field label="JobSchedule.Date" [horizontal]="false" cols=".">
                <div>
                    <ngb-datepicker
                        #dp
                        [(ngModel)]="date"
                        (dateSelect)="onDateChange($event)"
                        [minDate]="minDate"
                        [markDisabled]="isDayDisabled"
                    ></ngb-datepicker>
                </div>
            </abi-form-field>
            <div class="ml-3 w-100">
                <!--abi-form-field label="Current Appointments" [horizontal]="false"-->
                <!-- for JobAtBranch we need to show the Slots data for the Branch -->
                <abi-spinner position="relative" *ngIf="loading"></abi-spinner>
                <ng-container *ngIf="jobAtBranch; else normal_appointments">
                    <div
                        ngbRadioGroup
                        class="btn-group btn-group-toggle btn-group-vertical d-flex"
                        name="serviceTimeSlot"
                        [(ngModel)]="slotModel"
                    >
                        <ng-container
                            *ngIf="serviceTimeSlots.size; else noSlotsAvailable"
                        >
                            <label
                                *ngFor="let timeSlot of serviceTimeSlots | keyvalue"
                                ngbButtonLabel
                                class="btn-outline-primary ml-0 w-100"
                            >
                                <input
                                    ngbButton
                                    type="radio"
                                    [value]="timeSlot.key"
                                    [disabled]="
                                        bookedDate !== timeSlot.key &&
                                        !timeSlot.value.available
                                    "
                                    (click)="selectSlot(timeSlot.key)"
                                />{{ timeSlot.value.id }}
                                {{
                                    bookedDate !== timeSlot.key &&
                                    !timeSlot.value.available
                                        ? "(Unavailable)"
                                        : ""
                                }}
                            </label>
                        </ng-container>
                        <ng-template #noSlotsAvailable>
                            <p>{{ "JobSchedule.NoAppointments" | translate }}</p>
                        </ng-template>
                    </div>
                </ng-container>
                <ng-template #normal_appointments>
                    <div class="table-responsive">
                        <table
                            class="table table-sm mb-1"
                            *ngIf="appointments.length; else no_appointments"
                        >
                            <thead>
                                <tr>
                                    <th translate="Job.Date"></th>
                                    <th
                                        class="text-center"
                                        translate="JobSchedule.Appointments"
                                    ></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let dt of appointments">
                                    <td class="p-1">
                                        <button
                                            class="btn btn-outline-primary btn-sm"
                                            (click)="selectDate(dt.date)"
                                            [class.active]="
                                                date.valueOf() === dt.date.valueOf()
                                            "
                                        >
                                            {{ dt.date | date }}
                                        </button>
                                    </td>
                                    <td class="text-center">
                                        {{ blank(dt.count) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ng-template #no_appointments>
                            <p>{{ "JobSchedule.NoAppointments" | translate }}</p>
                        </ng-template>
                    </div>
                </ng-template>
                <!--/abi-form-field-->
            </div>
        </div>
        <div class="table-responsive">
            <table
                abi-table
                class="mt-2 table table-hover table-sm mb-2"
                [rows]="resources?.items"
                [columns]="columns"
                [trClass]="resourceTrStyle"
                *ngIf="loading || resources?.items?.length; else no_resources"
                [canFilter]="true"
                [pageLocally]="true"
                [pageSize]="pageSize"
                [page]="pageNumber"
                (filteredRows)="filteredResources($event)"
            >
                <ng-template td="resourceId" let-value="value" let-row="row">
                    <button
                        [class]="
                            'font-weight-bold btn btn-sm btn-block btn-outline-primary m-0'
                        "
                        [class.active]="value === resourceId"
                        (click)="changeResource(row)"
                    >
                        {{ resourceDisplaySetting('resourceId', row, row.resourceId) }}
                    </button>
                    <!-- + resourceStyle(dt)-->
                </ng-template>
                <ng-template td="" let-row="row">
                    {{ resourceName(row.resourceId) }}
                </ng-template>
                <ng-template
                    [td]="[
                        'maximum',
                        'allocated',
                        'jobType',
                        'postalCode',
                        'skills'
                    ]"
                    let-value="value"
                >
                    {{ blank(value) }}
                </ng-template>
            </table>
            <ng-template #no_resources>
                <p>{{ "JobSchedule.NoResources" | translate }}</p>
            </ng-template>

            <ng-container *ngIf="masterResources?.items?.length">
                <button
                    *ngIf="!allResources"
                    (click)="showAllResources()"
                    class="btn btn-primary pl-1 pb-1"
                >
                    <i class="fas fa-chevron-down"></i>&nbsp;{{
                        "JobSchedule.ShowAll" | translate
                    }}
                </button>
                <div *ngIf="allResources">
                    <ngb-pagination
                        class="float-left"
                        [collectionSize]="resourceListLength"
                        [(page)]="pageNumber"
                        [pageSize]="pageSize"
                        maxSize="6"
                        rotate="true"
                        boundaryLinks="true"
                    ></ngb-pagination>
                    <!-- (pageChange)="search(columns)"-->
                    <div
                        ngbDropdown
                        class="ml-md-3 d-inline-block"
                        container="body"
                    >
                        <button
                            class="btn btn-outline-primary"
                            id="pageSize"
                            ngbDropdownToggle
                        >
                            {{ pageSize }}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="pageSize">
                            <button
                                *ngFor="let ps of pageSizes"
                                class="dropdown-item"
                                (click)="setPageSize(ps)"
                            >
                                {{ ps }}
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="row">
            <abi-form-field
                label="JobSchedule.Reason"
                [horizontal]="false"
                cols="col-12"
                [noFormGroup]="true"
            >
                <textarea [(ngModel)]="reason"></textarea>
            </abi-form-field>
        </div>
</ng-template>

<ng-template #footer>
    <button
        type="button"
        class="btn btn-outline-primary"
        (click)="cancel()"
        translate="System.Cancel"
    ></button>
    <button
        [disabled]="!resourceId || !date || loading || submitting"
        type="button"
        class="btn btn-primary"
        (click)="accept()"
        translate="Job.Schedule"
        data-cy="schedule-job-accept"
    ></button>
</ng-template>
